import { Link } from "react-router-dom"
import { useSession } from "../../auth/session"
import { usePoints } from "../../redux/pointsSlice"
import { REWARD_POINTS_ENABLED } from "../../featureFlags"

// Reward-points balance shown top-right on the Dashboard, Store and Offers
// pages. Hidden entirely (no points fetch either) while reward points are
// FCS-hidden — the wrapper keeps the hook calls unconditional.
export default function PointsBalancePill() {
  if (!REWARD_POINTS_ENABLED) return null
  return <PointsBalancePillContent />
}

function PointsBalancePillContent() {
  const session = useSession()
  const accessToken = session.accessToken ?? ""
  const { data: points } = usePoints(accessToken)
  if (!points) return null
  const balance = (points.topups - points.spendings)
  return (
    <Link to="/points" className="dashboard-points">
      <span className="dashboard-points-label">REWARD POINTS: </span>
      <span className="dashboard-points-amount">
        {balance}
      </span>
    </Link>
  )
}
